<template>
  <div
    v-if="isAuthenticatedMiddlewareAuth"
    ref="mainDivNav"
    class="w-100"
  >
    <div
      v-if="isLoading"
      class="w-100 text-center my-3"
    >
      <b-spinner
        variant="success"
        style="width: 3rem; height: 3rem;"
        label="Large Spinner Text Centered"
      /> Loading...
    </div>
    <b-row class="align-items-center">
      <router-link
        v-if="showRequests"
        v-b-tooltip.hover.right="'Back to Resources'"
        :to="`/navigation`"
        class="m-2"
      >
        <b-icon icon="arrow-left" />Home
      </router-link>
      <router-link
        v-else
        v-b-tooltip.hover
        title="Back to Requests"
        :to="`/requests`"
        class="m-2"
      >
        <b-icon icon="arrow-left" />Back
      </router-link>
    </b-row>
    <b-tabs
      v-model="activeTab"
      pills
      card
      @input="handleTabChange"
    >
      <b-tab
        key="tabIPR"
        active
      >
        <template #title>
          <!-- Custom HTML for the tab title -->
          <span>
            Incoming Pending Requests
            <b-badge
              pill
              variant="danger"
            >
              {{ getTotalIncomingPendingAccessRequestsMiddleware || 0 }}
            </b-badge>
          </span>
        </template>
        <b-container
          fluid
          class="mt-2"
        >
          <b-row class="my-2">
            <b-container
              v-if="incomingPendingRequestList && incomingPendingRequestList.length >0"
              fluid
            >
              <b-row class="justify-content-start">
                <b-col class="m-0 p-0">
                  <b-button
                    v-if="isSingleSelectedNavigation"
                    v-b-tooltip.hover.bottom="`See Request Details`"
                    size="sm"
                    variant="success"
                    class="mr-2 p-1 btn-common"
                    @mouseover="onHover(`Navigation/detail${displayinTypeText}`)"
                    @mouseleave="onLeave"
                    @click="showPopup"
                  >
                    <b-icon
                      v-if="hoverDetails"
                      aria-label="See Request Details"
                      icon="card-list"
                    />
                    <b-icon
                      v-else
                      aria-label="See Request Details"
                      icon="card-list"
                    />
                  </b-button>
                  <b-button
                    v-if="isSingleSelectedNavigation"
                    v-b-tooltip.hover.bottom="`Approve Request`"
                    size="sm"
                    class="mr-2 p-1 btn-common btn-secondary"
                    @mouseover="onHover(`Navigation/approve${displayinTypeText}`)"
                    @mouseleave="onLeave"
                    @click="approveRequest"
                  >
                    <b-icon
                      v-if="hoverApprove"
                      aria-label="Approve Request"
                      icon="check-square-fill"
                    />
                    <b-icon
                      v-else
                      aria-label="Approve"
                      icon="check-square"
                    />
                  </b-button>
                  <b-button
                    v-if="isSingleSelectedNavigation"
                    v-b-tooltip.hover.bottom="'Reject Request'"
                    size="sm"
                    variant="danger"
                    class="mx-2 p-1 btn-common"
                    @click="rejectRequest"
                    @mouseover="onHover(`Navigation/reject${displayinTypeText}s`)"
                    @mouseleave="onLeave"
                  >
                    <b-icon
                      v-if="hoverReject"
                      aria-label="Reject Request"
                      icon="x-square-fill"
                      variant="info"
                    />
                    <b-icon
                      v-else
                      aria-label="Reject"
                      icon="x-square"
                      variant="info"
                    />
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </b-row>
        </b-container>
        <b-row
          v-if="incomingPendingRequestList && incomingPendingRequestList.length >0"
        >
          <b-col class="mx-auto">
            <b-row class="my-2">
              <b-col class="col-4 mr-1">
                <b-form-input
                  ref="searchInput"
                  v-model="filterText"
                  type="text"
                  placeholder="Search..."
                  @blur="handleBlur"
                />
              </b-col>
              <b-col class="col-2">
                <b-form-select
                  ref="pageSize"
                  v-model="selectedPageSize"
                  v-b-tooltip.hover.top="`Select Page Size`"
                  :options="pageSizeOptions"
                  placeholder="page size..."
                  @change="onPageSizeChanged"
                />
              </b-col>
              <b-col class="col-2">
                <b-form-select
                  ref="gridTheme"
                  v-model="selectedTheme"
                  v-b-tooltip.hover.top="`Select Theme`"
                  :options="themeOptions"
                  placeholder="select theme..."
                  @change="onThemeChanged"
                />
              </b-col>
            </b-row>
            <div :class="['ag-grid-container', agGridTheme]">
              <ag-grid-vue
                ref="agGridTab1"
                style="width: 100%; height: 100%;"
                :default-col-def="defaultColDef"
                :column-defs="columnDefsSingle"
                :row-data="incomingPendingRequestList"
                :grid-options="gridOptionsSingle"
                :pagination-number-formatter="paginationNumberFormatter"
                :row-style="rowStyle"
                @grid-ready="onGridReady"
                @selectionChanged="onCheckboxValueChanged"
                @first-data-rendered="onFirstDataRendered"
              />
            </div>
          </b-col>
        </b-row>
        <b-row v-else>
          <div class="mx-auto">
            <p>
              There are no incoming pending requests. Stay tuned with an incoming requests notification indicator.
            </p>
          </div>
        </b-row>
      </b-tab>
      <b-tab
        key="tabYPR"
      >
        <template #title>
          <span>
            Your Pending Requests
            <b-badge
              pill
              variant="danger"
            >
              {{ getTotalPersonalPendingAccessRequestsMiddleware || 0 }}
            </b-badge>
          </span>
        </template>
        <b-container
          fluid
          class="mt-2"
        >
          <b-row class="my-2">
            <b-container
              v-if="yourPendingRequestList && yourPendingRequestList.length >0"
              fluid
            >
              <b-row class="justify-content-start">
                <b-col class="m-0 p-0">
                  <b-button
                    v-if="isSingleSelectedNavigation"
                    v-b-tooltip.hover.bottom="`See Request Details`"
                    size="sm"
                    variant="success"
                    class="mx-2 p-1 btn-common"
                    @mouseover="onHover(`Navigation/detail${displayinTypeText}`)"
                    @mouseleave="onLeave"
                    @click="showPopup"
                  >
                    <b-icon
                      v-if="hoverDetails"
                      aria-label="See Request Details"
                      icon="card-list"
                    />
                    <b-icon
                      v-else
                      aria-label="See Request Details"
                      icon="card-list"
                    />
                  </b-button>
                  <b-button
                    v-if="isSelectedNavigation"
                    v-b-tooltip.hover.bottom="'Delete Request'"
                    size="sm"
                    variant="danger"
                    class="mx-2 p-1 btn-common"
                    @click="deleteSelected"
                    @mouseover="onHover(`Navigation/delete${displayinTypeText}s`)"
                    @mouseleave="onLeave"
                  >
                    <b-icon
                      v-if="hoverReject"
                      aria-label="Delete Request"
                      icon="trash"
                    />
                    <b-icon
                      v-else
                      aria-label="Reject"
                      icon="trash"
                    />
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </b-row>
        </b-container>
        <b-row v-if="yourPendingRequestList && yourPendingRequestList.length > 0">
          <b-col class="mx-auto">
            <b-row class="my-2">
              <b-col class="col-4 mr-1">
                <b-form-input
                  ref="searchInput"
                  v-model="filterText"
                  type="text"
                  placeholder="Search..."
                  @blur="handleBlur"
                />
              </b-col>
              <b-col class="col-2">
                <b-form-select
                  ref="pageSize"
                  v-model="selectedPageSize"
                  v-b-tooltip.hover.top="`Select Page Size`"
                  :options="pageSizeOptions"
                  placeholder="page size..."
                  @change="onPageSizeChanged"
                />
              </b-col>
              <b-col class="col-2">
                <b-form-select
                  ref="gridTheme"
                  v-model="selectedTheme"
                  v-b-tooltip.hover.top="`Select Theme`"
                  :options="themeOptions"
                  placeholder="select theme..."
                  @change="onThemeChanged"
                />
              </b-col>
            </b-row>
            <div :class="['ag-grid-container', agGridTheme]">
              <ag-grid-vue
                ref="agGridTab2"
                style="width: 100%; height: 100%;"
                :default-col-def="defaultColDef"
                :column-defs="columnDefsMulti"
                :row-data="yourPendingRequestList"
                :grid-options="gridOptionsMulti"
                :pagination-number-formatter="paginationNumberFormatter"
                :row-style="rowStyle"
                @grid-ready="onGridReady"
                @selectionChanged="onCheckboxValueChanged"
                @first-data-rendered="onFirstDataRendered"
              />
            </div>
          </b-col>
        </b-row>
        <b-row v-else>
          <div class="mx-auto">
            <p>
              Your personal pending requests are empty. Your requests are either already processed or you haven't requested so far.
            </p>
          </div>
        </b-row>
      </b-tab>
      <b-tab
        key="tabIPrR"
        title="Incoming Processed Requests"
      >
        <b-container
          fluid
          class="mt-2"
        >
          <b-row class="my-2">
            <b-container
              v-if="incomingProcessedRequestList && incomingProcessedRequestList.length >0"
              fluid
            />
          </b-row>
        </b-container>
        <b-row v-if="incomingProcessedRequestList && incomingProcessedRequestList.length >0">
          <b-col class="mx-auto">
            <b-row class="my-2">
              <b-col class="col-4 mr-1">
                <b-form-input
                  ref="searchInput"
                  v-model="filterText"
                  type="text"
                  placeholder="Search..."
                  @blur="handleBlur"
                />
              </b-col>
              <b-col class="col-2">
                <b-form-select
                  ref="pageSize"
                  v-model="selectedPageSize"
                  v-b-tooltip.hover.top="`Select Page Size`"
                  :options="pageSizeOptions"
                  placeholder="page size..."
                  @change="onPageSizeChanged"
                />
              </b-col>
              <b-col class="col-2">
                <b-form-select
                  ref="gridTheme"
                  v-model="selectedTheme"
                  v-b-tooltip.hover.top="`Select Theme`"
                  :options="themeOptions"
                  placeholder="select theme..."
                  @change="onThemeChanged"
                />
              </b-col>
            </b-row>
            <div :class="['ag-grid-container', agGridTheme]">
              <ag-grid-vue
                ref="agGridTab3"
                style="width: 100%; height: 100%;"
                :default-col-def="defaultColDef"
                :column-defs="columnDefsNoSelection"
                :row-data="incomingProcessedRequestList"
                :grid-options="gridOptionsNoSelection"
                :pagination-number-formatter="paginationNumberFormatter"
                :row-style="rowStyle"
                @grid-ready="onGridReady"
                @selectionChanged="onCheckboxValueChanged"
                @first-data-rendered="onFirstDataRendered"
              />
            </div>
          </b-col>
        </b-row>
        <b-row v-else>
          <div class="mx-auto">
            <p>
              There are no incoming processed requests. Checkout your incoming pending requests if you want to process.
            </p>
          </div>
        </b-row>
      </b-tab>
      <b-tab
        key="tabYPrR"
        title="Your Processed Requests"
      >
        <b-row v-if="yourProcessedRequestList && yourProcessedRequestList.length >0">
          <b-col class="mx-auto">
            <b-row class="my-2">
              <b-col class="col-4 mr-1">
                <b-form-input
                  ref="searchInput"
                  v-model="filterText"
                  type="text"
                  placeholder="Search..."
                  @blur="handleBlur"
                />
              </b-col>
              <b-col class="col-2">
                <b-form-select
                  ref="pageSize"
                  v-model="selectedPageSize"
                  v-b-tooltip.hover.top="`Select Page Size`"
                  :options="pageSizeOptions"
                  placeholder="page size..."
                  @change="onPageSizeChanged"
                />
              </b-col>
              <b-col class="col-2">
                <b-form-select
                  ref="gridTheme"
                  v-model="selectedTheme"
                  v-b-tooltip.hover.top="`Select Theme`"
                  :options="themeOptions"
                  placeholder="select theme..."
                  @change="onThemeChanged"
                />
              </b-col>
            </b-row>
            <div :class="['ag-grid-container', agGridTheme]">
              <ag-grid-vue
                ref="agGridTab4"
                style="width: 100%; height: 100%;"
                :default-col-def="defaultColDef"
                :column-defs="columnDefsNoSelection"
                :row-data="yourProcessedRequestList"
                :grid-options="gridOptionsNoSelection"
                :pagination-number-formatter="paginationNumberFormatter"
                :row-style="rowStyle"
                @grid-ready="onGridReady"
                @selectionChanged="onCheckboxValueChanged"
                @first-data-rendered="onFirstDataRendered"
              />
            </div>
          </b-col>
        </b-row>
        <b-row v-else>
          <div class="mx-auto">
            <p>
              Your personal resource access requests are empty. You can create new requests if you wish.
            </p>
          </div>
        </b-row>
      </b-tab>
    </b-tabs>
    <div>
      <b-modal
        v-model="showDetailsModal"
        title="Resource Access Request Details"
        :header-bg-variant="headerBgVariant"
        hide-footer
      >
        <b-card class="my-4 ml-3">
          <!-- Button to trigger the email request -->
          <b-card-header class="d-flex mx-auto pt-2">
            <b-card-title class="h6 mb-0 ml-2">
              <b-icon icon="info" /><span class="font-weight-bold"> Request Details</span>
            </b-card-title>
          </b-card-header>
          <b-card-body>
            <b-list-group class="justify-content-start wrapped-text">
              <b-list-group-item class="d-flex align-items-left wrapped-text">
                Requestor Name:
                <div
                  class="custom-badge wrapped-text"
                  variant="primary"
                  pill
                >
                  {{ requestedByName }}
                </div>
              </b-list-group-item>
              <b-list-group-item class="d-flex align-items-left wrapped-text">
                Requestor Email:
                <div
                  class="custom-badge wrapped-text"
                  variant="primary"
                  pill
                >
                  {{ requestedByEmail }}
                </div>
              </b-list-group-item>
              <b-list-group-item class="d-flex align-items-left wrapped-text overflow-auto">
                Requested Resource:
                <div
                  class="custom-badge wrapped-text"
                  variant="primary"
                  pill
                >
                  {{ requestedResource }}
                </div>
              </b-list-group-item>
              <b-list-group-item class="d-flex align-items-left wrapped-text">
                Requested On:
                <div
                  class="custom-badge wrapped-text"
                  variant="primary"
                  pill
                >
                  {{ requestedDate }}
                </div>
              </b-list-group-item>
              <b-list-group-item class="d-flex align-items-center wrapped-text">
                Resource Type:
                <div
                  class="custom-badge wrapped-text"
                  variant="primary"
                  pill
                >
                  {{ requestedResourceType }}
                </div>
              </b-list-group-item>
              <b-list-group-item class="d-flex align-items-center wrapped-text">
                Approval Status:
                <div
                  class="custom-badge wrapped-text"
                  variant="primary"
                  pill
                >
                  {{ accessStatus }}
                </div>
              </b-list-group-item>
            </b-list-group>
          </b-card-body>
          <div class="d-flex justify-content-end">
            <b-button
              variant="secondary m-2 btn-sm"
              @click="cancelApproval"
            >
              {{ activeTab === 0 ? 'Cancel' : 'Close' }}
            </b-button>
            <b-button
              v-if="activeTab === 0"
              variant="primary m-2 btn-sm"
              @click="approveRequest"
            >
              Approve
            </b-button>
            <b-button
              v-if="activeTab === 0"
              variant="danger m-2 btn-sm"
              @click="rejectRequest"
            >
              Reject
            </b-button>
          </div>
        </b-card>
      </b-modal>
    </div>
    <div>
      <b-modal
        v-model="showConfirmationModal"
        @ok="confirm"
        @cancel="cancel"
      >
        <template #modal-title>
          Confirm Action
        </template>
        <template #default>
          Are you sure you want to proceed?
        </template>
      </b-modal>
    </div>
    <div>
      <b-modal
        v-model="showConfirmationModal"
        title="Confirmation"
        cancel-title="No"
        ok-title="YES"
        @ok="confirm"
        @cancel="cancel"
      >
        <p>Do you want to {{ approveOrReject }} the access request?</p>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { AgGridVue } from 'ag-grid-vue';
import djuliImage from '@/assets/MainMenu/djuliImage.png';
import { getAuth } from 'firebase/auth';
import {firebaseApp} from '@/firebaseConfig';
const notifyZone = 'Requests'
const Requests = 'Requests'
const auth = getAuth(firebaseApp);

export default {
	name: Requests,
	components: {
		AgGridVue,
	},
	data() {
		return {
			djuliImage: djuliImage,
			showRequests: true,
			showDetailsModal:false,
			showConfirmationModal:false,
			hoverReject: false,
			hoverDetails: false,
			hoverApprove: false,
			hoverSend: false,
			incomingPendingRequestList: [],
			incomingProcessedRequestList: [],
			yourPendingRequestList:[],
			yourProcessedRequestList:[],
			routeList: [],
			dictIdReports: {},
			isLoading: false,
			isSearchFocused: false,
			rowData: null,
			selectedRows: [],
			displayinTypeText: 'Requests',
			gridApi: null,
			columnApi: null,
			selectedPageSize: 20,
			isAbove500px: true,
			paginationNumberFormatter: null,
			agGridTheme: 'ag-theme-alpine',
			selectedTheme: 'ag-theme-alpine',
			filterText: '',
			headerBgVariant: 'light',
			approveOrReject:'',
			approvalType:'',
			approvalStatus:'Pending',
			rowStyle: { cursor: 'pointer' },
			selectedRecord: {
				projectName:'',
				clusterName:'',
				reportName:'',
				requestedByName:'',
				requestedByEmail:'',
				requestedToName:'',
				requestedToEmail:'',
				requestDate:null,
				status:'Pending',
				requestId:null,
				entityName:'',
				resourceType:'',
				clusterId:null,
				projectId:null,
				reportId:null
			},
			activeTab:0,
			defaultColDef: {
				editable: false,
				sortable: true,
				resizable: true,
				filter: true,
				flex: 1,
			},
      gridOptionsMulti: {
				rowSelection: 'multiple',
				pagination: true,
				paginationPageSize: 20,
				domLayout: 'autoHeight',
				rowBuffer: 10,
				suppressHorizontalScroll: false,
				suppressNoRowsOverlay: true, // Hide the "No Rows" overlay
				suppressLoadingOverlay: true, // Hide the loading overlay
			},
			gridOptionsSingle: {
				rowSelection: 'single',
				pagination: true,
				paginationPageSize: 20,
				domLayout: 'autoHeight',
				rowBuffer: 10,
				suppressHorizontalScroll: false,
				suppressNoRowsOverlay: true, // Hide the "No Rows" overlay
				suppressLoadingOverlay: true, // Hide the loading overlay
			},
      gridOptionsNoSelection: {
				suppressRowClickSelection: true, // Rows won't be selected when clicked
				pagination: true,
				paginationPageSize: 20,
				domLayout: 'autoHeight',
				rowBuffer: 10,
				suppressHorizontalScroll: false,
				suppressNoRowsOverlay: true, // Hide the "No Rows" overlay
				suppressLoadingOverlay: true, // Hide the loading overlay
			},
			// The options for the page size selector input
			pageSizeOptions: [
				{ value: 20, text: 'page size...' },
				{ value: 7, text: '7' },
				{ value: 15, text: '15' },
				{ value: 50, text: '50' },
				{ value: 100, text: '100' },
				{ value: 150, text: '150' },
				{ value: 200, text: '200' },
			],
			themeOptions: [
				{ value: 'ag-theme-alpine', text: 'select theme...' },
				{ value: 'ag-theme-alpine', text: 'Alpine(Default)' },
				{ value: 'ag-theme-blue', text: 'Blue' },
				{ value: 'ag-theme-dark', text: 'Dark' },
			],
			// Columns definition for the cluster tables
      columnDefsMulti: [
				{
					headerName: ' ', field: 'checkbox', suppressSizeToFit: true, checkboxSelection: true,
					headerCheckboxSelection: true, maxWidth: 50, sortable: false, filter: false, flex: 1
				},
				{ headerName: 'ID', field: 'Id', maxWidth: 80, sort: 'asc', filter: false, flex: 1 },
				{ headerName: 'Resource Name', field: 'entityName', autoHeight: true, wrapText: true, flex: 1 },
				{ headerName: 'Resource Type', field: 'resourceType', autoHeight: true, wrapText: true, flex: 1 },
				{ headerName: 'Requested By', field: 'requestedByName', autoHeight: true, wrapText: true, flex: 1 },
				{ headerName: 'Requested For', field: 'requestedToName', autoHeight: true, width: 100, flex: 1 },
				{ headerName: 'Request Date', field: 'requestDate', autoHeight: true, wrapText: true, width: 200, flex: 1 },
				{ headerName: 'Access Status', field: 'status', autoHeight: true, wrapText: true, width: 200, flex: 1 }
			],
      columnDefsSingle: [
				{
					headerName: ' ', field: 'checkbox', suppressSizeToFit: true, checkboxSelection: true,
					headerCheckboxSelection: false, maxWidth: 50, sortable: false, filter: false, flex: 1
				},
				{ headerName: 'ID', field: 'Id', maxWidth: 80, sort: 'asc', filter: false, flex: 1 },
				{ headerName: 'Resource Name', field: 'entityName', autoHeight: true, wrapText: true, flex: 1 },
				{ headerName: 'Resource Type', field: 'resourceType', autoHeight: true, wrapText: true, flex: 1 },
				{ headerName: 'Requested By', field: 'requestedByName', autoHeight: true, wrapText: true, flex: 1 },
				{ headerName: 'Requested For', field: 'requestedToName', autoHeight: true, width: 100, flex: 1 },
				{ headerName: 'Request Date', field: 'requestDate', autoHeight: true, wrapText: true, width: 200, flex: 1 },
				{ headerName: 'Access Status', field: 'status', autoHeight: true, wrapText: true, width: 200, flex: 1 }
			],
			columnDefsNoSelection: [
				{ headerName: 'ID', field: 'Id', maxWidth: 80, sort: 'asc', filter: false, flex: 1 },
				{ headerName: 'Resource Name', field: 'entityName', autoHeight: true, wrapText: true, flex: 1 },
				{ headerName: 'Resource Type', field: 'resourceType', autoHeight: true, wrapText: true, flex: 1 },
				{ headerName: 'Requested By', field: 'requestedByName', autoHeight: true, wrapText: true, flex: 1 },
				{ headerName: 'Requested For', field: 'requestedToName', autoHeight: true, width: 100, flex: 1 },
				{ headerName: 'Request Date', field: 'requestDate', autoHeight: true, wrapText: true, width: 200, flex: 1 },
				{ headerName: 'Access Status', field: 'status', autoHeight: true, wrapText: true, width: 200, flex: 1 }
			],
		};
	},
	computed: {
		...mapGetters([
			'isSelectedNavigation',
			'isSingleSelectedNavigation',
			'getDisplayNameMiddlewareAuth',
			'isAllowEditNavigation',
			'getResourceAccessRequestsMiddleware',
			'getEmailMiddlewareAuth',
			'getTotalIncomingPendingAccessRequestsMiddleware',
			'getTotalPersonalPendingAccessRequestsMiddleware',
			'isAuthenticatedMiddlewareAuth'
		]),
		cardSizeClass() {
			// Add a CSS class based on the display size
			if (window.innerWidth < 768) {
				return 'small-card';
			} else if (window.innerWidth < 992) {
				return 'medium-card';
			} else {
				return 'large-card';
			}
		},
		requestedByName(){
			return this.selectedRecord.requestedByName;
		},
		requestedByEmail(){
			return this.selectedRecord.requestedByEmail;
		},
		requestedResource(){
			return this.selectedRecord.entityName;
		},
		requestedDate(){
			return this.selectedRecord.requestDate;
		},
		accessStatus(){
			return this.selectedRecord.status;
		},
		requestedResourceType(){
			return this.selectedRecord.resourceType;
		}
	},
	async mounted() {
		// Add the resize event listener when the component is mounted
		window.addEventListener('resize', this.handleResize);
		// Check the window size initially
		this.handleResize();
		await this.updateShowedElements(true, this.activeTab);
		await this.setSelectedNavigation(0)
		this.showRequests = true;
	},
	async created() {
		this.paginationNumberFormatter = (params) => {
			return '[' + params.value.toLocaleString() + ']';
		};
		this.$watch(
			async () => this.$route.params,
      async () => {
        await this.updateShowedElements(false, this.activeTab);
    }
		);
		await this.fetchResourceAccessRequestsMiddleware({email: auth.currentUser.email});
	},
	async unmounted() {
		// Remove the resize event listener when the component is about to be unmounted
		window.removeEventListener('resize', this.handleResize);
	},
	watch: {
		filterText(newValue) { // Search for both clusters/projects grid and reports grid
			if (this.$refs.agGridTab1) {
				this.$refs.agGridTab1.gridOptionsSingle.api.setQuickFilter(newValue);
			}
			if (this.$refs.agGridTab2) {
				this.$refs.agGridTab2.gridOptionsMulti.api.setQuickFilter(newValue);
			}
			if (this.$refs.agGridTab3) {
				this.$refs.agGridTab3.gridOptionsNoSelection.api.setQuickFilter(newValue);
			}
			if (this.$refs.agGridTab4) {
				this.$refs.agGridTab4.gridOptionsNoSelection.api.setQuickFilter(newValue);
			}
		},
	},
	methods: {
		...mapActions([
			'setForceUpdReprtsTableReportViewer',
			'setContextOnHover',
			'setConfigSharingWindow',
			'setSelectedNavigation',
			'setAllowEditNavigation',
			'setAllowEditReportViewer',
			'addMessageTerminalSection',
			'fetchResourceAccessRequestsMiddleware',
			'approveResourceAccessRequestMiddleware',
			'rejectResourceAccessRequestMiddleware',
			'deleteResourceAccessRequestMiddleware',
			'shareReportMiddleware',
			'shareClusterMiddleware'
		]),
		onGridReady(params) {
			this.gridApi = params.Api;
			this.columnApi = params.getColumnApi;
		},
		async handleTabChange(newTab) {
      this.activeTab = newTab;
			await this.setSelectedNavigation(0);
			await this.updateShowedElements(false, this.activeTab);
    },
		async onCheckboxValueChanged(event) {
			this.selectedRows = event.api.getSelectedNodes();
			await this.setSelectedNavigation(this.selectedRows.length);
			this.selectedRecord.reportName = this.selectedRows[0]?.data.reportName ? this.selectedRows[0]?.data.reportName: '';
			this.selectedRecord.projectName = this.selectedRows[0]?.data.projectName ? this.selectedRows[0]?.data.projectName: '';
			this.selectedRecord.clusterName = this.selectedRows[0]?.data.clusterName ? this.selectedRows[0]?.data.clusterName: '';
			this.selectedRecord.requestedByName = this.selectedRows[0]?.data.requestedByName ? this.selectedRows[0]?.data.requestedByName : '';
			this.selectedRecord.requestedByEmail = this.selectedRows[0]?.data.requestedByEmail ? this.selectedRows[0]?.data.requestedByEmail : '';
			this.selectedRecord.requestedToName = this.selectedRows[0]?.data.requestedToName ? this.selectedRows[0]?.data.requestedToName : '';
			this.selectedRecord.requestedToEmail = this.selectedRows[0]?.data.requestedToEmail ? this.selectedRows[0]?.data.requestedToEmail : '';
			this.selectedRecord.requestDate = this.selectedRows[0]?.data.requestDate ? this.selectedRows[0]?.data.requestDate : null;
			this.selectedRecord.status = this.selectedRows[0]?.data.status ? this.selectedRows[0]?.data.status : 'Pending';
			this.selectedRecord.requestId = this.selectedRows[0]?.data.requestId ? this.selectedRows[0]?.data.requestId : null;
			this.selectedRecord.clusterId = this.selectedRows[0]?.data.clusterId ? this.selectedRows[0]?.data.clusterId : null;
			this.selectedRecord.projectId = this.selectedRows[0]?.data.projectId ? this.selectedRows[0]?.data.projectId : null;
			this.selectedRecord.reportId = this.selectedRows[0]?.data.reportId ? this.selectedRows[0]?.data.reportId : null;
			this.selectedRecord.entityName = this.selectedRows[0]?.data.entityName ? this.selectedRows[0]?.data.entityName:null;
			this.selectedRecord.resourceType = this.selectedRows[0]?.data.resourceType ? this.selectedRows[0]?.data.resourceType:null;
		},
		async showPopup() {
		this.showDetailsModal = true;
		},
		async closePopup() {
		this.showDetailsModal = false;
		},
		async handleBlur() {
			// Clear the search box content when it loses focus
			this.filterText = '';
		},
		async handleResize() {
			// Update the isAbove500px flag based on the window size
			this.isAbove500px = window.innerWidth > 500;
		},
		async onFirstDataRendered(params) {
			this.gridApi = params.api;
			this.columnApi = params.getColumnApi;
		},
		async onPageSizeChanged() {
			var value = this.selectedPageSize;
			this.gridApi.paginationSetPageSize(Number(value));
		},
		async onThemeChanged() {
			this.agGridTheme = this.selectedTheme;
		},
		onHover(route) {
			this.setContextOnHover(route)
		},
		onLeave() {
			this.setContextOnHover(null)
		},
		handleRejectHover(hovered) {
			//Handle the hover on the Add button
			this.hoverReject = hovered;
		},
		handleDetailHover(hovered) {
			//Handle the hover on the Add button
			this.show
			this.hoverDetails = hovered;
		},
		handleApproveHover(hovered) {
			//Handle the hover on the Add button
			this.hoverApprove = hovered;
		},
		handleSendHover(hovered) {
			//Handle the hover on the Add button
			this.hoverSend = hovered;
		},
		async refresh() {
			await this.updateShowedElements(true, this.activeTab)
		},
		async updateShowedElements(forceUpdate = false, activeTab) {
			this.setAllowEditNavigation(true)
			this.displayinTypeText = 'Requests';
			this.mainTitle = 'Requests';
			try {
				this.isLoading = true;
				if (forceUpdate || this.getResourceAccessRequestsMiddleware === null) {
					const success = await this.fetchResourceAccessRequestsMiddleware({email: auth.currentUser.email})
					if (!success) {
						return
					}
				}
				const listItems = this.getResourceAccessRequestsMiddleware;
				let allRequestList = [];
				let entityName = null;
				for (let j = 0; j < listItems.length; j++){
					if(listItems[j].timeOfRequestHandled && listItems[j].isAllowed){
						this.approvalStatus = 'Granted';
					}
					else if(listItems[j].timeOfRequestHandled && !listItems[j].isAllowed){
						this.approvalStatus = 'Denied';
					}
					else {
						this.approvalStatus = 'Pending';
					}
					if(listItems[j].resourceType === 'Cluster'){
						entityName =  listItems[j].clusterName;
					}
					else if(listItems[j].resourceType === 'Project'){
						entityName =  listItems[j].projectName;
					}
					else{
						entityName =  listItems[j].reportName;
					}
					allRequestList.push({
							Id: j,
							requestId:listItems[j].id,
							reportName: listItems[j].reportName,
							projectName: listItems[j].projectName,
							clusterName: listItems[j].clusterName,
							requestedByName: listItems[j].requestedByName,
							requestedByEmail: listItems[j].requestedByEmail,
							requestedToName: listItems[j].requestedToName,
							requestedToEmail: listItems[j].requestedToEmail,
							reportId: listItems[j].reportId,
							projectId: listItems[j].projectId,
							clusterId: listItems[j].clusterId,
							requestedById: listItems[j].requestByUserHandle,
							requestedToId: listItems[j].requestToUserHandle,
							requestDate: listItems[j].timeOfRequest,
							status: this.approvalStatus,
							resourceType: listItems[j].resourceType,
							entityName: entityName,
					});
				}
				if(activeTab === 0){
					// Incoming pending requests filtered from the all list of requests for a specific user
					const incomingPendingRequest = allRequestList.filter(obj=>(obj.requestedToEmail === auth.currentUser.email) && (obj.status ==='Pending'))
					incomingPendingRequest.forEach((obj, index) => {
						obj.Id = index + 1;
					});
					this.incomingPendingRequestList = incomingPendingRequest;
				}
				else if(activeTab ===1){
					// Your pending requests filtered from the list of all requests for a specific user
					const yourPendingRequest = allRequestList.filter(obj=> (obj.requestedByEmail === auth.currentUser.email) && (obj.status ==='Pending')  ) // TODO: email should be fetched from store
					yourPendingRequest.forEach((obj, index) => {
						obj.Id = index + 1;
					});
					this.yourPendingRequestList = yourPendingRequest;
				}
				else if(activeTab ===2){
					// Incoming requests already processed filtered from the all list of requests for a specific user
					const incomingProcessedRequest = allRequestList.filter(obj=> (obj.requestedToEmail === auth.currentUser.email) && (obj.status !=='Pending'))
					incomingProcessedRequest.forEach((obj, index) => {
						obj.Id = index + 1;
					});
					this.incomingProcessedRequestList = incomingProcessedRequest;
				}
				else if(activeTab ===3){
					// Incoming pending requests filtered from the all list of requests for a specific user
					const yourProcessedRequest = allRequestList.filter(obj=>(obj.requestedByEmail === auth.currentUser.email) && (obj.status !=='Pending')  ) // TODO: email should be fetched from store
					yourProcessedRequest.forEach((obj, index) => {
						obj.Id = index + 1;
					});
					this.yourProcessedRequestList = yourProcessedRequest;
				}
				else {
					this.activeTab = 0;
					this.incomingProcessedRequestList =[];
				}

			}
			catch (error) {
				const errText = 'Error retrieving the requests from the server, please try in a few minutes.'
				const errTitle = 'Conection failed'
				this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, Requests)
			} finally {
				this.isLoading = false;
			}
		},
		async deleteSelected() {
			let selectedRows = this.gridApi.getSelectedNodes();
			if (selectedRows.length === 0) {
				await this.$alert(
					'Please select at least one request',
					'Removing Requests',
							'info',
						)
				return
			}
			const mssgReports = selectedRows.length === 1 ? 'You will delete a request' : 'You will delete multiple requests. Are you sure you want to delete them all?'
			try {
				await this.$confirm(
					mssgReports,
					'Confirm Deletion',
					'question',
					{
						confirmButtonText: 'Remove',
					}
				)
			}
			catch {
				return
			}
      let removeSuccess = true
			try {
				this.isLoading = true;
				for (let j = 0; j < selectedRows.length; j++) {
					const requestId = selectedRows[j].data.requestId;
					const response = await this.deleteResourceAccessRequestMiddleware({
						requestId: requestId
					})
					if (!response.success) {
						const errTitle = 'Error removing the request'
						const errText = `Error removing the request '${this.selectedRecord.data?.entityName || 'selected'}'. Please try again in a few seconds`
						this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, Requests)
					}
					removeSuccess = removeSuccess && response.success
				}
				this.isLoading = false;
			} catch (error) {
				const errTitle = 'Error'
				const errText = 'Error while deleting requests, please try again'
				this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, Requests)
			}
      if (removeSuccess) {
        this.$alert(
          `Request${selectedRows.length>1?'s':''} removed successfully.`,
          'Success',
          'success',
        )
      }
			await this.updateShowedElements(true, this.activeTab)
		},
		async approveRequest(){
			this.approveOrReject = '\'Approve\'';
			this.approvalType = 'Approval';
			this.showConfirmationModal = true;
		},
		async rejectRequest(){
			this.approveOrReject = '\'Reject\'';
			this.approvalType = 'Rejection';
			this.showConfirmationModal = true;
		},
		async cancelApproval(){
			this.showDetailsModal = false;
		},
		async confirm() {
			if(this.approvalType === 'Approval'){
				const success = await this.approveResourceAccessRequestMiddleware({
						requestId:  this.selectedRecord.requestId
				});
        if(!success){
          await this.$alert(
						'Approval failed. Please retry in a few seconds',
						'Approval Status',
						'error',
					)
          return
        }
				let responseShare = {success:false};
				if (this.selectedRecord.resourceType === 'Cluster'){ // Cluster sharing
						responseShare = await this.shareClusterMiddleware({
							users: [{
								email: this.selectedRecord.requestedByEmail,
								name: this.selectedRecord.requestedByName,
								accesstype: true
							}],
							clusterId: this.selectedRecord.clusterId,
							clusterName: this.selectedRecord.clusterName
					})
				}
				else if(this.selectedRecord.resourceType=== 'Project'){ // Project sharing
					//TODO: Project sharing is not yet implemented
				}
				else { // Report sharing
					responseShare = await this.shareReportMiddleware({
							reports: [{
								id: this.selectedRecord.reportId,
								name:this.selectedRecord.reportName
							}],
							users: [{
								email: this.selectedRecord.requestedByEmail,
								name: this.selectedRecord.requestedByName,
								accesstype: true
							}],
							clusterId: this.selectedRecord.clusterId,
							clusterName: this.selectedRecord.clusterName
					})
				}
				await this.updateShowedElements(true, this.activeTab)
				this.showConfirmationModal = false;
				this.showDetailsModal = false;
				if (success && responseShare.success){
					await this.$alert(
						'Approved and Shared Successfully!',
						'Approval Status',
						'info',
						)
				}
			}
			else if (this.approvalType === 'Rejection'){
				const success = await this.rejectResourceAccessRequestMiddleware({requestId:  this.selectedRecord.requestId});
				await this.updateShowedElements(true, this.activeTab);
				this.showConfirmationModal = false;
				this.showDetailsModal =false;
				if (success){
					await this.$alert(
						'Rejected Successfully!',
						'Rejection Status',
						'info',
						)
				}else{
          await this.$alert(
						'Rejected failed. Please retry in a few seconds',
						'Rejected Status',
						'error',
					)
        }
			}
			else{
				const infoTitle = 'No Action Selected';
				const infoText = 'Go back and choose what to do';
				const infoZone = notifyZone;
				this.$notifTerm.addNotification(this.$notifTerm.typesNotif.INFO, infoTitle, infoText, infoZone);
				this.showConfirmationModal = false;
				this.showDetailsModal = false;
				return;
			}
			this.showConfirmationModal = false;
		},
		async cancel() {
			this.showConfirmationModal = false;
		}
	}

}

</script>
<style lang="scss" scoped>
@import '~ag-grid-community/dist/styles/ag-grid.css'; // Core grid CSS, always needed
@import '~ag-grid-community/dist/styles/ag-theme-alpine.css';
@import '~ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham-dark.css';
@import '~ag-grid-community/dist/styles/ag-theme-blue.css';
@import '~ag-grid-community/dist/styles/ag-theme-dark.css';
@import '~ag-grid-community/dist/styles/ag-theme-fresh.css';
@import '~ag-grid-community/dist/styles/ag-theme-material.css';

.welcome-mssg {
	margin: 0;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 22rem;
}

.djuliLogo-mssg {
	width: 15rem;
	margin-left: 3rem;
	opacity: 1
}

.sharing-window {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 103;
}

.btn-common {
	box-shadow: 0 2px 4px 0 #aaa;
}

.header-welcome {
	font-size: 1.4rem;
	font-weight: bold;
	margin-bottom: 0.5rem;
}

.project-title {
	font-size: 1.75rem;
	font-weight: bold;
	margin-bottom: 0.5rem;
}

.action-cell {
	display: flex;
	justify-content: center;
	align-items: center;
}

@media (max-width: 768px) {
	.ag-grid-container {
		width: 100%;
		height: 400px;
		display: flex;
		overflow: auto !important;
		/* Enable horizontal scrolling */
		// display: flex !important; /* Use flexbox to allow the grid to grow and shrink */
	}
}

.hand-cursor {
	cursor: pointer !important;
}

.sticker-container {
	position: relative !important;
}

.floating-card {
	position: absolute !important;
	top: 5px;
	right: 2px;
	border-radius: 10px;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	margin-right: 10px;
	padding: 0%;
	background-color: #e9ecef;
}

.small-card {
	font-size: 9px;
	max-width: 100px;
}

.medium-card {
	font-size: 11px;
	max-width: 200px;
}

.large-card {
	font-size: 13px;
	max-width: 300px;
	max-height: 200px;
}

.centered-header {
	display: block;
	text-align: center;
}
.custom-badge {
	display: flex;
  flex-wrap: wrap; /* Allow items to wrap to the next line */
  align-items: center; /* Center vertically */
  text-align: left; /* Align text to the left horizontally */
	background-color: #4DBF45;
	border-radius: 10px; /* You can adjust the radius value as needed */
  padding: 5px;
}
.overflow-auto {
  overflow: auto; /* Add scrollbars when content overflows */
}
</style>
